import { FormatsService } from '@techrules/pipelib';
import { Component, OnInit, ViewChild } from '@angular/core';
import { LoginService } from '@tech-services/login.service';
import { CommonService } from '@tech-services/common.service';
import { ActivatedRoute, Router } from '@angular/router';
import { SessionService } from '@tech-services/session.service';
import { TranslateService } from '@ngx-translate/core';
import {
  UntypedFormGroup,
  Validators,
  UntypedFormBuilder,
} from '@angular/forms';

import { IconDefinition, faSpinner } from '@fortawesome/pro-solid-svg-icons';
import { environment } from '@tech-environments/environment';

import { Subject } from 'rxjs';
import { MatButton } from '@angular/material/button';
import { AppConfig } from '@tech-utils/app-config.service';
import { takeUntil } from 'rxjs/operators';
import { ProfileportfolioService } from '@tech-services/profileportfolio.service';
import { TechDialogsService } from '../../shared/tech-dialogs.service';
import { MatDialog } from '@angular/material/dialog';
import { TwoFAComponent } from './two-fa/two-fa.component';
import { TechConfirmModel } from '../../shared/techconfirmationdialog/techmodaldialog.model';

const urlParams = new URLSearchParams(window.location.search);
const urlEmail = urlParams.get('email');

@Component({
  selector: 'tech-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit {
  @ViewChild('btnSignin', { static: true }) btnSignin: MatButton;
  private unsubscribe$ = new Subject<void>();
  public form: UntypedFormGroup;
  public faSpinner: IconDefinition = null;
  public languageDefault = AppConfig.settings.language;
  public bussinesAreaData: any;
  languages = [];
  public hide = true;
  public logoUrl =
    './assets/img/' +
    localStorage.getItem('ThemeImg') +
    '/WealthRules-265px.png';
  public img = 'FondoLogin.jpg';
  public backEffect: boolean = JSON.parse(AppConfig.settings.backgroundEffect);
  public version: string = environment.appVersion;
  public domain = localStorage.getItem('Domain');
  public customTheme = localStorage.getItem('ThemeImg');
  public allowOpenNewAccount: boolean =
    localStorage.getItem('MainSettings') == 'true'
      ? JSON.parse(localStorage.getItem('AllowOpenNewAccount'))
      : AppConfig.settings.allowOpenNewAccount;
  public allowOpenNewAccountWithEmail: boolean =
    localStorage.getItem('MainSettings') == 'true'
      ? JSON.parse(localStorage.getItem('allowOpenNewAccountWithEmail'))
      : AppConfig.settings.allowOpenNewAccountWithEmail;
  public twoFAActive = AppConfig.settings.twoFAActive;

  constructor(
    protected loginService: LoginService,
    protected commonService: CommonService,
    protected sessionService: SessionService,
    private router: Router,
    private route: ActivatedRoute,
    private translate: TranslateService,
    private fb: UntypedFormBuilder,
    private dialogService: TechDialogsService,
    private formatsService: FormatsService,
    private profilePortfolioService: ProfileportfolioService,
    public dialog: MatDialog
  ) {
    this.newform();
  }

  ngOnInit() {
    // console.log(urlEmail);
    if (urlEmail) {
      this.form.get('username').setValue(urlEmail);
    }
    this.loadMainSetting();
    let showThemeToggle = this.route.snapshot.paramMap.get('changetheme');
    localStorage.setItem(
      'showThemeToggle',
      showThemeToggle
        ? showThemeToggle === 'changetheme'
          ? 'true'
          : 'false'
        : 'false'
    );
    this.randomBackgroundImage();
    this.sessionService.portfolioCode = '';
    this.loginService
      .getBussinesAreaData(AppConfig.settings.domain)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((data) => {
        this.bussinesAreaData = data;
        if (localStorage.getItem('MainSettings') != 'true') {
          this.translate.use(this.bussinesAreaData.Language);
          this.sessionService.language = this.bussinesAreaData.Language;
          localStorage.setItem('Language', this.bussinesAreaData.Language);
          this.languageDefault = this.bussinesAreaData.Language;
          this.languages = this.bussinesAreaData.DomainLanguages;
          this.formatsService.locale = this.bussinesAreaData.Language;
        }
        this.detectBrowserLanguage();
        this.detectBrowserLanguage();
      });
    //Fuerza que tome el language de la direccion
    if (this.route.snapshot.paramMap.get('language') != null) {
      this.commonService.forcedLanguageSource.next(true);
      this.translate.setDefaultLang(
        this.route.snapshot.paramMap.get('language')
      );
      this.translate.use(this.route.snapshot.paramMap.get('language'));
      this.sessionService.language =
        this.route.snapshot.paramMap.get('language');
      localStorage.setItem(
        'Language',
        this.route.snapshot.paramMap.get('language')
      );
    } else {
      this.sessionService.language = localStorage.getItem('Language');
      this.translate.use(localStorage.getItem('Language'));
    }
    // localStorage.setItem('Language', AppConfig.settings.language);
    localStorage.setItem('Domain', AppConfig.settings.domain);
    this.sessionService.domain = AppConfig.settings.domain;
    this.translate.get('k000014').subscribe((text: string) => {
      this.commonService.setTitle(text + ' | ' + AppConfig.settings.tabTitle);
    });
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next(null);
    this.unsubscribe$.complete();
  }

  public newform() {
    this.form = this.fb.group({
      username: ['', [Validators.required]],
      password: ['', [Validators.required]],
    });
  }

  public changeLanguage($event) {
    this.translate.use($event.value);
    this.sessionService.language = $event.value;
    localStorage.setItem('Language', $event.value);
    this.translate.setDefaultLang(localStorage.getItem('Language'));
  }

  public onSignin(forcelogin: boolean) {
    this.faSpinner = faSpinner;
    const value = this.form.value;
    const deviceid = this.commonService.getDeviceId().toString();
    this.commonService.deviceidSource.next(deviceid);
    this.commonService.loading$.emit(true);

    this.loginService
      .validationLoginClientRest(value.password, value.username, deviceid, forcelogin )
      .subscribe(
        (data: any) => {
          this.sessionService.clientDataLogin = data;
          this.sessionService.sessionToken = data.access_token;
          localStorage.setItem('SessionClientToken', data.access_token);
          localStorage.removeItem('isAdvisor');
          this.form.reset();
          this.commonService.loading$.emit(false);
          this.router.navigate(['/portfolios']);

          //this.comprobacionportfolio();
        },
        (err) => {
          switch (err.status) {
            case 302:
              this.faSpinner = null;
              this.form.reset(); 
              this.commonService.loading$.emit(false);
              if (this.twoFAActive) {
                this.commonService.verificationIdSource.next(
                  err.error.verificationid
                );
                this.sessionService.clientCode = err.error.usercode;
                localStorage.setItem('ClientCode', err.error.usercode);
                this.openDialogTwoFA();
              }
              break;
            case 403:
              this.faSpinner = null;
              this.form.reset(); 
              this.commonService.loading$.emit(false);
              if (err.error.Status == 'MAX_ATTEMPTS') {
                localStorage.setItem('MaxAttempts', 'true');
                this.openDialogTwoFA();
              } else {
                this.commonService.errorManager(err.error.Code, err);
              }
              break;
            case 409:
              if(err.error.Code == 'Multiple_Users'){
                let dialogData = new TechConfirmModel();
                this.translate.get('uPojENgToGkjTiHWXg3MTk').subscribe((text) => {
                  dialogData.cancelText = text; //token: Mantener la otra sesión
                });
                this.translate.get('rohFfa6KvjqK93t2hL7s8L').subscribe((text) => {
                  dialogData.confirmText = text; //token: Usar esta sesión
                });
                this.translate.get('gUJzsoi38MksypxFxjkg95').subscribe((text) => {
                  dialogData.title = '<center>' + text + '</center>'; //Token: Sesión ya iniciada
                });
                this.translate.get('9dAF6MsAWsAitpbDiV5oz2').subscribe((text) => {
                  dialogData.message = '<center>' + text + '</center>'; //Token: Ya existe una sesión activa con estas credenciales en otro dispositivo o navegador. ¿Deseas continuar con esta sesión aquí o mantener la sesión anterior?
                });
                this.commonService.loading$.emit(false);
                this.dialogService.openConfirmDialogWidth(dialogData);
                this.dialogService
                  .confirmedDialog()
                  .pipe(takeUntil(this.unsubscribe$))
                  .subscribe((data) => {
                    if (data) { 
                      this.onSignin(true);
                    }else{
                      this.form.reset();
                      this.faSpinner = null;
                    }
                  });
              }else{
                this.faSpinner = null;
                this.form.reset(); 
                this.commonService.loading$.emit(false);
                this.commonService.errorManager(err.error.Code, err);
              }
              break;
            default:
              this.faSpinner = null;
              this.form.reset(); 
              this.commonService.loading$.emit(false);
              this.commonService.errorManager(err.error.Code, err);
              break;
          }
        }
      );
  }

  private comprobacionportfolio() {
    this.profilePortfolioService.getPortfolios().subscribe((data) => {
      if (data.length > 2 || !data.length) {
        this.router.navigate(['/portfolios']);
      } else {
        this.commonService.portfolioCodeSource.next(data[0].PortfolioCode);
        this.router.navigate(['/profileportfolio']); //profileportfolio
      }
    });
  }

  public randomBackgroundImage() {
    let numberImages = 12;
    let includeCero = false;
    let min = includeCero ? 0 : 1;
    let number = Math.floor(Math.random() * (numberImages - min)) + min;
    this.img =
      number < 10
        ? 'FondoLogin_0' + number + '.jpg'
        : 'FondoLogin_' + number + '.jpg';
  }

  private loadMainSetting() {
    let MainSettings;
    let Language;
    let ThemeImg;
    let ThemeCss;
    let OnboardingType;
    let AllowOpenNewAccount;
    let SmsVerification;
    let twoFARetryTime;
    let twoFAWrongAttempts;
    let twoFAResendAttempts;
    let sessionToken;
    let userCode;

    if (
      localStorage.getItem('SessionToken') !== undefined &&
      localStorage.getItem('SessionToken')
    )
      sessionToken = localStorage.getItem('SessionToken');
    if (
      localStorage.getItem('UserCode') !== undefined &&
      localStorage.getItem('UserCode')
    )
      userCode = localStorage.getItem('UserCode');
    if (
      localStorage.getItem('TwoFARetryTime') !== undefined &&
      localStorage.getItem('TwoFARetryTime')
    )
      twoFARetryTime = localStorage.getItem('TwoFARetryTime');
    if (
      localStorage.getItem('TwoFAWrongAttempts') !== undefined &&
      localStorage.getItem('TwoFAWrongAttempts')
    )
      twoFAWrongAttempts = localStorage.getItem('TwoFAWrongAttempts');
    if (
      localStorage.getItem('TwoFAResendAttempts') !== undefined &&
      localStorage.getItem('TwoFAResendAttempts')
    )
      twoFAResendAttempts = localStorage.getItem('TwoFAResendAttempts');

    if (localStorage.getItem('MainSettings') == 'true') {
      MainSettings = true;
      Language = localStorage.getItem('Language');
      ThemeImg = localStorage.getItem('ThemeImg');
      ThemeCss = localStorage.getItem('ThemeCss');
      OnboardingType = localStorage.getItem('OnboardingType');
      AllowOpenNewAccount = localStorage.getItem('AllowOpenNewAccount');
      SmsVerification = localStorage.getItem('SmsVerification');
    }
    localStorage.clear();
    if (sessionToken !== undefined && sessionToken)
      localStorage.setItem('SessionToken', sessionToken);
    if (userCode !== undefined && userCode)
      localStorage.setItem('UserCode', userCode);
    if (twoFARetryTime !== undefined && twoFARetryTime)
      localStorage.setItem('TwoFARetryTime', twoFARetryTime);
    if (twoFAWrongAttempts !== undefined && twoFAWrongAttempts)
      localStorage.setItem('TwoFAWrongAttempts', twoFAWrongAttempts);
    if (twoFAResendAttempts !== undefined && twoFAResendAttempts)
      localStorage.setItem('TwoFAResendAttempts', twoFAResendAttempts);
    if (MainSettings) {
      localStorage.setItem('Language', Language);
      localStorage.setItem('ThemeImg', ThemeImg);
      localStorage.setItem('ThemeCss', ThemeCss);
      localStorage.setItem('OnboardingType', OnboardingType);
      localStorage.setItem('AllowOpenNewAccount', AllowOpenNewAccount);
      localStorage.setItem('SmsVerification', SmsVerification);
      localStorage.setItem('MainSettings', 'true');
    } else {
      localStorage.setItem('Language', AppConfig.settings.language);
      localStorage.setItem('ThemeImg', AppConfig.settings.customTheme);
      var customThemeFile = AppConfig.settings.customThemeFile.replace(
        '.json',
        ''
      );
      localStorage.setItem('ThemeCss', customThemeFile);
      localStorage.setItem('OnboardingType', AppConfig.settings.onboardingType);
      localStorage.setItem(
        'AllowOpenNewAccount',
        AppConfig.settings.allowOpenNewAccount.toString()
      );
      localStorage.setItem(
        'SmsVerification',
        AppConfig.settings.SMSVerification
      );
    }
  }

  openDialogTwoFA() {
    const dialogRef = this.dialog.open(TwoFAComponent);
    dialogRef.afterClosed().subscribe((result) => {
      if (!result) {
        this.form.reset();
        this.faSpinner = null;
      }
    });
  }

  
  private detectBrowserLanguage(): void {
    const browserLang = navigator.language || (navigator.languages && navigator.languages[0]);
    if (browserLang) {
      const languageCode = browserLang.split('-')[0]; // Obtiene la parte principal del idioma (ej: "es" de "es-ES")
      const matchedLanguage = this.languages.find(lang => lang.FullCode.startsWith(languageCode) || lang.ShortCode === languageCode);
      if (matchedLanguage) {
        this.languageDefault = matchedLanguage.FullCode;
        this.changeLanguage({ value: this.languageDefault });
      }
    }
  }
}
